import {Component, Input, ViewChild} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {BaseComponent} from "../../base/base.component";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-access-category-detail',
  templateUrl: './saAccessCategory-detail.component.html'
})
export class SaAccessCategoryDetailComponent extends BaseComponent {

  @Input()
  categoryId:any;

  category:any;
  saUsers:any[];
  locks:any[];

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              public authService:AuthService,
              private lookupService:LookupService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    if (this.categoryId) {
      this.loadId(this.categoryId);
    } else {
      this.route.params
        .subscribe((params: Params) => {
          let id:any = params['id'];
          if (id === '0') {
            this.createNew();
          } else {
            this.loadId(id);
          }
        });
    }
    this.loadLocks();
    this.loadSaUsers();
  }

  loadId(id) {
    this.http.get(`${this.env.e.url}/access/categories/${id}`).subscribe(
      data => {
        this.setCategory(data);
      }
    );
  }

  loadLocks() {
    this.http.get(`${this.env.e.url}/access/saLocks/all`).subscribe(
      data => {
        let locks = data as any[];
        for (let lock of locks) {
          lock.siteName = lock.controller.siteName;
          lock.regionName = lock.controller.regionName;
          lock.plDisplayName = `${lock.regionName ?? ''}.${lock.siteName ?? ''}.${lock.name}`;
        }
        this.locks = locks;
      }
    );
  }

  loadSaUsers() {
    this.http.get(`${this.env.e.url}/auth/users/service/SITE_ACCESS`).subscribe(
      data => {
        let users = data as any[];
        for (let user of users) {
          user.department = this.lookupService.lookup("auth", "departments", user.departmentId, "");
          user.plDisplayName = `${user.department} / ${user.username} (${user.firstName} ${user.lastName})`;
        }
        this.saUsers = users;
      }
    );
  }

  setCategory(category:any, loadSites = true) {
    this.category = category;
  }

  createNew() {
    this.setCategory({
      id: undefined,
      name: undefined,
      shortCode: undefined,
      description: undefined,
      lockIds: [],
      userIds:[]
    })
  }

  save() {
    if (!this.category.id) {
      this.http.post(`${this.env.e.url}/access/categories`, this.category)
        .subscribe(
          data => {
            this.setCategory(data, false);
            this.alertService.info(`Created ${this.category.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/access/categories/${this.category.id}`, this.category)
        .subscribe(
          data => {
            this.alertService.info(`Updated ${this.category.name}`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/access/categories/${this.category.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.category.name}`);
          this.router.navigate(["/access/categories"]);
        }
      );
  }

  userDisplayCallback(user, component) {
    if (!user || user == "-1")
      return undefined;
    if (user?.firstName === undefined)
      return undefined;
    return `${user.firstName} ${user.lastName} (${user.username})`
  }
}
